import Api from "./Api";
import store from "../state/store";

export default {
  async fetchTimesheet() {
    const entity_id = store.getters["authfack/currentEntity"].id
    const res = await Api({ daemonRequest: false }).get(
      `/time_sheet/${entity_id}`
    );
    return res;
  },
  async prepareTimeSheet(params) {
    const entity_id = store.getters["authfack/currentEntity"].id
    const res = await Api({ daemonRequest: false }).post(
      `/time_sheet/${entity_id}`, params
    )
    return res;
  },
  async sitesUserTypes(site_ids) {
    return await Api({ daemonRequest: false }).get(
      `/user-types/sites/flows`,
      {
        params: { site_ids }
      }
    );
  }
};
